const skills = [
  {
    category: "Product Craft",
    items: ["Product strategy", "Design systems", "UX writing", "Rapid prototyping"]
  },
  {
    category: "Frontend",
    items: ["React / Next.js", "Nuxt", "Tailwind CSS", "Framer Motion", "Expo"]
  },
  {
    category: "Backend & Data",
    items: ["Node & Express", "Supabase", "Xano", "Postgres / MySQL", "API architecture"]
  },
  {
    category: "Low-Code / Hybrid",
    items: ["WeWeb", "Webflow", "Wized", "Knack"]
  },
  {
    category: "AI & Automation",
    items: ["OpenAI APIs", "Claude / MCP", "Zapier & n8n", "Twilio", "SendGrid"]
  }
];

export default skills;
